declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined
let initialized = false

export function initGoogleAnalytics(): void {
  if (initialized || !measurementId || typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []

  // GA4 exige un objet Arguments (pas un array) pour reconnaître les commandes
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer!.push(arguments) } as (...args: unknown[]) => void

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', measurementId, { send_page_view: false })
  initialized = true
}

export function trackPageView(path: string): void {
  if (!measurementId || typeof window === 'undefined') return
  initGoogleAnalytics()
  window.gtag?.('event', 'page_view', {
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
  })
}

/**
 * Envoie un évènement GA4 personnalisé (ex. conversion de formulaire).
 * Sans effet si GA n'est pas configuré (VITE_GA_MEASUREMENT_ID absent).
 */
export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  if (!measurementId || typeof window === 'undefined') return
  initGoogleAnalytics()
  window.gtag?.('event', eventName, params)
}

/**
 * Conversion de génération de lead (formulaire soumis avec succès).
 * `generate_lead` est l'évènement de conversion recommandé par GA4 ;
 * `form_type` permet de segmenter par formulaire dans GA4.
 */
export function trackLead(formType: string, params?: Record<string, unknown>): void {
  trackEvent('generate_lead', { form_type: formType, ...params })
}
